module.exports = "/_next/static/images/googleAuthen-516142391a057113749d30038918768c.svg";